module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-4x t-loading-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e6d1b8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/LoadingIcon.vue
// module id = 557
// module chunks = 1